const CurrencyCashConfig = {
  "USD": {
    "country": "United States",
    "coins": ["1¢", "5¢", "10¢", "25¢", "50¢", "$1"],
    "notes": ["$1", "$2", "$5", "$10", "$20", "$50", "$100"]
  },
  "GBP": {
    "country": "United Kingdom",
    "coins": ["1p", "2p", "5p", "10p", "20p", "50p", "£1", "£2"],
    "notes": ["£5", "£10", "£20", "£50"]
  },
  "EUR": {
    "country": "European Union",
    "coins": ["1c", "2c", "5c", "10c", "20c", "50c", "€1", "€2"],
    "notes": ["€5", "€10", "€20", "€50", "€100", "€200", "€500"]
  },
  "INR": {
    "country": "India",
    "coins": ["₹1", "₹2", "₹5", "₹10", "₹20"],
    "notes": ["₹10", "₹20", "₹50", "₹100", "₹200", "₹500", "₹2000"]
  },
  "CAD": {
    "country": "Canada",
    "coins": ["1¢", "5¢", "10¢", "25¢", "50¢", "$1", "$2"],
    "notes": ["$5", "$10", "$20", "$50", "$100"]
  },
  "AUD": {
    "country": "Australia",
    "coins": ["5c", "10c", "20c", "50c", "$1", "$2"],
    "notes": ["$5", "$10", "$20", "$50", "$100"]
  },
  "NZD": {
    "country": "New Zealand",
    "coins": ["10c", "20c", "50c", "$1", "$2"],
    "notes": ["$5", "$10", "$20", "$50", "$100"]
  },
  "JMD": {
    "country": "Jamaica",
    "coins": ["$1", "$5", "$10", "$20"],
    "notes": ["$50", "$100", "$500", "$1000", "$5000"]
  },
  "CHF": {
    "country": "Switzerland",
    "coins": ["5c", "10c", "20c", "50c", "1 CHF", "2 CHF", "5 CHF"],
    "notes": ["10 CHF", "20 CHF", "50 CHF", "100 CHF", "200 CHF", "1000 CHF"]
  },
  "QAR": {
    "country": "Qatar",
    "coins": ["1 dirham", "5 dirhams", "10 dirhams", "25 dirhams", "50 dirhams"],
    "notes": ["1 riyal", "5 riyals", "10 riyals", "50 riyals", "100 riyals", "200 riyals", "500 riyals"]
  },
  "AED": {
    "country": "United Arab Emirates",
    "coins": ["1 fils", "5 fils", "10 fils", "25 fils", "50 fils", "1 dirham"],
    "notes": ["5 AED", "10 AED", "20 AED", "50 AED", "100 AED", "200 AED", "500 AED", "1000 AED"]
  },
  "SAR": {
    "country": "Saudi Arabia",
    "coins": ["5 halala", "10 halala", "25 halala", "50 halala", "1 riyal", "2 riyals"],
    "notes": ["1 riyal", "5 riyals", "10 riyals", "20 riyals", "50 riyals", "100 riyals", "200 riyals", "500 riyals"]
  },
  "SGD": {
    "country": "Singapore",
    "coins": ["5¢", "10¢", "20¢", "50¢", "$1"],
    "notes": ["$2", "$5", "$10", "$20", "$50", "$100", "$1000"]
  }
};

export default CurrencyCashConfig;
